import React from 'react';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import parse from 'html-react-parser';
export default function PromoHeader(props) {
    const { activePromo, enablePromoHeader } = props;
    const promoHeader = React.useRef();
    const hasActivePromo = !!activePromo && Object.keys(activePromo).length > 0;
    React.useEffect(() => {
        if (!activePromo || Object.keys(activePromo).length === 0) {
            return undefined;
        }
        function handleResize() {
            var _a;
            const promoHeight = (_a = promoHeader === null || promoHeader === void 0 ? void 0 : promoHeader.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
            enablePromoHeader(promoHeight);
        }
        let timeout;
        function onResize() {
            clearTimeout(timeout);
            timeout = setTimeout(handleResize, 100);
        }
        handleResize();
        window.addEventListener('resize', onResize);
        return function cleanUp() {
            clearTimeout(timeout);
            window.removeEventListener('resize', onResize);
        };
    }, [activePromo, enablePromoHeader, promoHeader]);
    if (hasActivePromo) {
        return (React.createElement(Grid, { container: true, ref: promoHeader, sx: {
                justifyContent: 'center',
                backgroundColor: 'secondary.light',
            } },
            React.createElement(Link, { key: activePromo.cta_url, sx: {
                    py: 2.5, color: '#FFFFFF !important',
                }, underline: "none", href: activePromo.cta_url, "aria-label": activePromo.promo_text }, parse(activePromo.promo_text || ''))));
    }
    return null;
}
